<template>
    <div>
        <SearchableSelect v-if="!this.companyId" :items="companiesOptions" placeholder="Selecione uma empresa"
            @item-selected="selectCompany" />
        <SearchableSelect v-if="!this.sectionId && this.args.companyId" :items="sectionsOptions"
            placeholder="Selecione um trecho" @item-selected="selectSection" />

        <div class="form-group">
            <div v-if="section?.assignor">
                <label for="assignees" class="col-form-label">Cedente</label>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" :id="'assignee-' + section?.id"
                        :value="section.assignor?.id" v-model="args.sendAssignor">
                    <label :for="'assignee-' + section.id" class="form-check-label">
                        {{ section.assignor?.id }} - {{ section.assignor?.name }}
                    </label>
                </div>
            </div>

            <div v-if="section?.assignees">
                <label for="assignees" class="col-form-label">Cessionários</label>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="assigness" v-model="args.sendAllAssigness" />
                    <label class="form-check-label" for="assigness">
                        Enviar para todos
                    </label>
                </div>
                <div v-if="!args.sendAllAssigness" class="form-check">
                    <div v-for="assignee in section.assignees" :key="assignee.id">
                        <input type="checkbox" class="form-check-input" :id="'assignee-' + assignee.id"
                            :value="assignee.id" v-model="args.assignessList">
                        <label :for="'assignee-' + assignee.id" class="form-check-label">
                            {{ assignee.id }} - {{ assignee.name }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-check">
                <div class="form-group">
                    <label for="additionalNotes" class="col-form-label">Mensagem</label>
                    <textarea class="form-control w-100" id="additionalNotes" v-model="args.body" rows="4"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchableSelect from '@/components/SearchableSelect.vue';
import { CompanyService, sectionService } from '@/services/backend/ApiService';

export default {
    components: {
        SearchableSelect
    },
    props: {
        companyId: {
            type: String,
            required: false,
        },
        sectionId: {
            type: String,
            required: false
        },
        modelValue: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            companiesOptions: [],
            sectionsOptions: [],
            section: {},
            args: {
                companyId: null,
                sectionId: null,
                sendAllAssigness: false,
                sendAssignor: null,
                assignessList: [],
                body: String
            }
        };
    },
    async mounted() {
        if (!this.companyId) {
            this.companiesOptions = (await CompanyService.findAll()).map(value => {
                return {
                    option: `${value.id} - ${value.name}`,
                    value: value.id
                }
            })
        }

        if (this.modelValue) {
            this.args = this.modelValue;

            if (!this.modelValue.assignessList) {
                this.args.assignessList = [];
            }
        }

        this.initiateVariables()        
    },
    methods: {
        async initiateVariables() {
            this.section = await sectionService.findOne(this.sectionId);
            this.args.sectionId = this.sectionId;
            this.args.companyId = this.companyId;
        },
        async selectCompany(value) {
            this.args.companyId = value;
            this.args.sectionId = null;
            this.sectionsOptions = (await sectionService.findAll({ company: {id: value} })).map(value => {
                return {
                    value: value.id,
                    option: `${value.id} - ${value.name}`
                }
            });
        },
        async selectSection(value) {
            this.section = await sectionService.findOne(value);
            this.args.sectionId = value;
        }
    },
    watch: {
        modelValue(newValue) {
            this.args = newValue;
        },
        args: {
            handler(newValue) {
                this.$emit('update:modelValue', this.args);
            },
            deep: true,
        }
    }
};
</script>
